


















































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Notification } from 'element-ui'
import { finalize } from 'rxjs/operators'
import $Api from '@api'
import store from '@/store'
import Clipboard from 'clipboard'
import { translate } from '@/utils/filters'

@Component
export default class GenerateReturnCodeDialog extends Vue {
    @Prop({ default: false })
    show!: boolean
    @Prop({ default: '' })
    cameraId!: string
    @Prop({ default: () => [] })
    repaymentIds!: string[]
    disabled = true
    showCode = false
    form: any = {
        cameraId: '',
        repaymentAmount: '',
        penaltyAmount: '',
        payType: '',
        calcAmount: '',
        capitalAmount: '',
        interestAmount: '',
        feesAmount: '',
        overdueFee: '',
        repaymentPlans: [],
        payChannel: ''
    }
    req = {}
    rules = {
        cameraId: { required: true, message: translate('common.noEmpty') },
        repaymentAmount: { required: true, message: translate('common.noEmpty') },
        payType: { required: true, message: translate('common.noEmpty') },
        payChannel: { required: true, message: translate('common.noEmpty') }
    }
    selects = []
    visible = this.show
    timeoutId: any = -1
    delayed = 0
    // 返回码
    returnCode = ''
    returnCodeNumber = ''
    cameraIdDisabled = false
    payChannels = []
    previewError = ''

    get isMerged(): boolean {
        return this.repaymentIds.length > 0
    }

    get isReturnCodeUrl(): boolean {
        return /^https?:\/\//i.test(this.returnCode)
    }

    // @Watch('form.repaymentAmount')
    // @Watch('form.cameraId')
    onPayChanged() {
        if (this.isMerged) return
        if (this.form.repaymentAmount !== '' && this.form.calcAmount !== '' && this.form.repaymentAmount === this.form.calcAmount && !this.disabled) return
        this.disabled = true
        this.selects = []
        this.payChannels = []
        this.form.payType = ''
        this.form.payChannel = ''
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
            if (!this.visible) return
            if (this.form.cameraId === '' && this.form.repaymentAmount === '') return
            if (this.form.cameraId === '' && this.form.repaymentAmount !== '') return

            const { cameraId, repaymentAmount: paidAmount } = this.form
            const tenantId = store.getters.tenantId

            $Api.receiptService
                .repaymentTotalAmountByOrderId({ cameraId, paidAmount, tenantId })
                .subscribe(
                    data => {
                        this.form = Object.assign(this.form, data)
                        this.form.repaymentAmount = data.calcAmount
                        this.disabled = data.repayAmount === 0 || this.form.repaymentAmount === 0
                        this.previewError = ''
                        this.loadRepaymentPayTypes()
                        this.delayed = 500
                    },
                    err => {
                        this.delayed = 500
                        this.disabled = true
                        console.log(err)
                    }
                )
        }, this.delayed)
    }
    selectChannelConfig(payType: string) {
        this.payChannels = []
        this.form.payChannel = ''
        this.getChannelConfig(payType)
    }

    getChannelConfig(payType : string) {
        const tenantId = store.getters.tenantId
        const bankId = +payType === 1 ? -3 : +payType === 2 ? -4 : 0
        if (!bankId) {
            this.payChannels = []
            return
        }
        $Api.receiptService.repaymentPayChannelList({ bankId, tenantId }).subscribe(data => {
            this.payChannels = data.data || []
            if (this.payChannels.length === 1) this.form.payChannel = (this.payChannels[0] as any).channelId
        })
    }

    @Watch('show')
    onShowChanged(show: boolean) {
        this.visible = show
    }

    @Watch('cameraId')
    onIncomeIdChanged(cameraId: string) {
        this.form.cameraId = cameraId
    }

    open() {
        this.previewError = ''
        this.form.cameraId = this.cameraId
        this.selects = []
        this.payChannels = []
        this.form.payType = ''
        this.form.payChannel = ''
        if (this.isMerged) {
            this.loadMergedPreview()
        } else {
            this.onPayChanged()
        }
        this.cameraIdDisabled = this.cameraId !== ''
    }

    loadMergedPreview() {
        this.disabled = true
        const params = {
            cameraId: this.cameraId,
            repaymentIds: this.repaymentIds,
            tenantId: store.getters.tenantId
        }
        $Api.receiptService.repaymentTotalAmountByOrderId(params).subscribe(
            data => {
                this.form = Object.assign(this.form, data)
                this.form.cameraId = data.cameraIdStr || String(data.cameraId)
                this.form.lid = data.lidStr || String(data.lid)
                this.form.repaymentAmount = data.calcAmount
                this.disabled = data.repayAmount === 0 || data.calcAmount === 0
                this.previewError = ''
                this.loadRepaymentPayTypes()
            },
            err => {
                this.previewError = err.message || translate('repayment.merge.previewFailed')
                this.disabled = true
            }
        )
    }

    loadRepaymentPayTypes() {
        $Api.receiptService.repaymentPayTypeList({
            merchantId: store.getters.tenantId,
            amount: this.form.repaymentAmount
        }).subscribe(
            data => {
                this.selects = data || []
                if (this.selects.length === 1) {
                    this.form.payType = (this.selects[0] as any).payType
                    this.selectChannelConfig(this.form.payType)
                }
            },
            err => {
                this.previewError = err.message
            }
        )
    }

    @Emit('update:show')
    close() {
        clearTimeout(this.timeoutId)
        ;(this.$refs['form'] as any).resetFields()
        this.$emit('update:cameraId', '')
        this.delayed = 0
        return false
    }

    createCode() {
        (this.$refs['form'] as any).validate((valid: boolean) => {
            if (valid) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })

                const params = {
                    tenantId: store.getters.tenantId,
                    payType: this.form.payType,
                    lid: this.form.lid,
                    repaymentAmount: this.form.repaymentAmount,
                    indexs: this.form.indexs,
                    cameraId: this.form.cameraId,
                    channelId: this.form.payChannel,
                    repaymentIds: this.isMerged ? this.repaymentIds : undefined
                }

                $Api.receiptService
                    .createRepaymentCode(params)
                    .pipe(
                        finalize(async () => {
                            await this.$nextTick(() => { /* 以服务的方式调用的 Loading 需要异步关闭 */ })
                            loading.close()
                        })
                    )
                    .subscribe(
                        data => {
                            this.returnCode = data.repaymentCode
                            this.returnCodeNumber = data.bankName
                            this.showCode = true
                            this.close()
                            this.$emit('onCreateCode', true)
                        },
                        err => {
                            Notification.error(err.message as string)
                        }
                    )
            } else {
                return false
            }
        })
    }

    copyReturnCode() {
        let clipboard = new Clipboard('.copyButton')
        clipboard.on('success', () => {
            this.$message({
                type: 'success',
                message: translate('icon.copy') + translate('common.success')
            })
            this.showCode = false
            this.close()
        })
        clipboard.on('error', () => {
            this.$message({
                type: 'error',
                message: 'Can not copy'
            })
        })
    }

    openReturnCode() {
        window.open(this.returnCode, '_blank', 'noopener')
    }
}
